import { render, staticRenderFns } from "./familyMobileDialog.vue?vue&type=template&id=36057310&scoped=true"
import script from "./familyMobileDialog.vue?vue&type=script&lang=js"
export * from "./familyMobileDialog.vue?vue&type=script&lang=js"
import style0 from "./familyMobileDialog.vue?vue&type=style&index=0&id=36057310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36057310",
  null
  
)

export default component.exports